<template>
  <CallPonButton class="btn" @click="open()"/>
</template>

<script setup>
  import { usePonPopup } from '@/Groups/Pon/private/imports/toggleDropdown';
  //---------------------------------------
  import CallPonButton from '@/Groups/Pon/private/core/CallPonButton/CallPonButton.vue';
  //---------------------------------------
  const { open } = usePonPopup();
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>